import { devtools } from 'zustand/middleware'
import { create, StateCreator } from 'zustand'

const isUndefined = (value: unknown) => value === undefined

type WebsiteMediaFileType = {
  id: string
  path: string
  mimeType?: string
}

type WebsiteQuestionType = 'MULTIPLE_CHOICE' | 'ESSAY'

type WebsiteQuestionConfigType = {
  type: WebsiteQuestionType
  count: number
}

// Types
// States type
interface WebsiteConfigStoreStatesType {
  name: string | null
  logo: WebsiteMediaFileType | null
  banner: WebsiteMediaFileType | null
  banners: WebsiteMediaFileType[]
  guideVideo: WebsiteMediaFileType | null
  questionConfig: WebsiteQuestionConfigType[]
  theme: string | null
  previewTheme: string | null
}

// Actions type
interface SetWebsiteConfigParamsType {
  name?: string | null
  logo?: WebsiteMediaFileType | null
  banner?: WebsiteMediaFileType | null
  banners?: WebsiteMediaFileType[]
  guideVideo?: WebsiteMediaFileType | null
  questionConfig?: WebsiteQuestionConfigType[]
  theme?: string | null
  previewTheme?: string | null
}

interface ThemeStoreActionsType {
  setWebsiteConfig: (params: SetWebsiteConfigParamsType) => void
}

// Constants
const DEFAULT_THEME_STORE_STATES: WebsiteConfigStoreStatesType = {
  name: null,
  logo: null,
  banner: null,
  banners: [],
  guideVideo: null,
  questionConfig: [],
  theme: null,
  previewTheme: null
}

// Define store
const websiteConfigStore: StateCreator<WebsiteConfigStoreStatesType & ThemeStoreActionsType> = (set) => {
  return {
    // States
    ...DEFAULT_THEME_STORE_STATES,

    // Actions
    setWebsiteConfig: ({ name, logo, banner, banners, guideVideo, questionConfig, theme, previewTheme }) => {
      set((state) => ({
        name: isUndefined(name) ? state.name : name,
        logo: isUndefined(logo) ? state.logo : logo,
        banner: isUndefined(banner) ? state.banner : banner,
        banners: isUndefined(banners) ? state.banners : banners,
        guideVideo: isUndefined(guideVideo) ? state.guideVideo : guideVideo,
        questionConfig: isUndefined(questionConfig) ? state.questionConfig : questionConfig,
        theme: isUndefined(theme) ? state.theme : theme,
        previewTheme: isUndefined(previewTheme) ? state.previewTheme : previewTheme
      }))
    }
  }
}

const useWebsiteConfigStore = create(
  devtools(websiteConfigStore, {
    name: 'website-config-store'
  })
)

export default useWebsiteConfigStore
